"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
Object.defineProperty(exports, "__esModule", { value: true });
var kendo_react_inputs_1 = require("@progress/kendo-react-inputs");
var React = require("react");
var reactstrap_1 = require("reactstrap");
var AdditionalRegistrants = /** @class */ (function (_super) {
    __extends(AdditionalRegistrants, _super);
    function AdditionalRegistrants(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            ddlState: [],
            ddlGuestType: [],
            Registrantmodal: false,
            DeleteModal: false,
            AddTitle: {},
            UpdateTitle: { display: 'none' },
            divCheckbox: { display: 'flex' },
            Registrants_arr: [],
            GuestIdMax: 0,
            GuestRowIndex: '',
            GuestFName: '',
            GuestLName: '',
            GuestEmail: '',
            GuestAddress1: '',
            GuestCity: '',
            GuestZipCode: '',
            GuestAddress2: '',
            GuestState: '',
            GuestType: '',
            GuestTypeOther: '',
            tdGuestOther: { display: 'none' },
            lblResult: '',
            button: 'mode'
        };
        _this.handleSameAddress = function (e) {
            if (e.target.checked) {
                _this.setState({ GuestAddress1: _this.props.Address1 });
                _this.setState({ GuestAddress2: _this.props.Address2 });
                _this.setState({ GuestCity: _this.props.City });
                _this.setState({ GuestState: _this.props.State });
                _this.setState({ GuestZipCode: _this.props.Zip });
            }
            else {
                _this.setState({ GuestAddress1: '', GuestAddress2: '', GuestCity: '', GuestState: '', GuestZipCode: '' });
            }
        };
        fetch('api/ListItems/State')
            .then(function (response) { return response.json(); })
            .then(function (list) {
            _this.setState({ ddlState: list });
        }).catch(function (error) {
            console.log(error);
        });
        fetch('api/ListItems/RegistrantType')
            .then(function (response) { return response.json(); })
            .then(function (list) {
            _this.setState({ ddlGuestType: list });
        }).catch(function (error) {
            console.log(error);
        });
        _this.handleSubmit = _this.handleSubmit.bind(_this);
        _this.Add = _this.Add.bind(_this);
        _this.toggle = _this.toggle.bind(_this);
        _this.ShowRegistrantModal = _this.ShowRegistrantModal.bind(_this);
        _this.CloseDeleteModal = _this.CloseDeleteModal.bind(_this);
        _this.CloseRegistrantModal = _this.CloseRegistrantModal.bind(_this);
        _this.Clear = _this.Clear.bind(_this);
        _this.FillForm = _this.FillForm.bind(_this);
        _this.Edit = _this.Edit.bind(_this);
        _this.DeleteGuest = _this.DeleteGuest.bind(_this);
        _this.handleSameAddress = _this.handleSameAddress.bind(_this);
        _this.handleGuestTypeOther = _this.handleGuestTypeOther.bind(_this);
        return _this;
    }
    AdditionalRegistrants.prototype.componentDidUpdate = function (prevProps) {
        if (this.state.Registrants_arr !== prevProps.Registrants_arr)
            this.GetArrayObj();
    };
    AdditionalRegistrants.prototype.ShowRegistrantModal = function () {
        this.setState({ Registrantmodal: !this.state.Registrantmodal });
        this.setState(function () { return ({ AddTitle: { display: 'flex' } }); });
        this.setState(function () { return ({ UpdateTitle: { display: 'none' } }); });
        this.setState(function () { return ({ divCheckbox: { display: 'flex' } }); });
    };
    AdditionalRegistrants.prototype.toggle = function () {
        this.setState({
            Registrantmodal: !this.state.Registrantmodal
        });
    };
    AdditionalRegistrants.prototype.CloseDeleteModal = function () {
        this.setState({
            DeleteModal: !this.state.DeleteModal
        });
    };
    AdditionalRegistrants.prototype.CloseRegistrantModal = function () {
        this.Clear();
        this.setState({
            Registrantmodal: !this.state.Registrantmodal
        });
    };
    AdditionalRegistrants.prototype.Clear = function () {
        this.setState({ GuestFName: '' });
        this.setState({ GuestLName: '' });
        this.setState({ GuestEmail: '' });
        this.setState({ GuestAddress1: '' });
        this.setState({ GuestCity: '' });
        this.setState({ GuestZipCode: '' });
        this.setState({ GuestAddress2: '' });
        this.setState({ GuestState: '' });
        this.setState({ GuestType: '' });
        this.setState({ GuestTypeOther: '' });
        this.setState(function () { return ({ tdGuestOther: { display: 'none' } }); });
        this.setState({ lblResult: '' });
        this.setState({ GuestRowIndex: '' });
    };
    AdditionalRegistrants.prototype.handleSubmit = function (event) {
        event.preventDefault();
        event.stopPropagation();
        if (this.state.button === 'add') {
            this.Add();
        }
        if (this.state.button === 'update') {
            this.Edit();
        }
    };
    AdditionalRegistrants.prototype.Add = function () {
        var arrNew = __spreadArray([], this.state.Registrants_arr);
        this.setState({ GuestIdMax: this.state.GuestIdMax + 1 });
        var newObj = { ID: this.state.GuestIdMax, Fname: this.state.GuestFName, Lname: this.state.GuestLName, Email: this.state.GuestEmail, Address1: this.state.GuestAddress1, City: this.state.GuestCity, State: this.state.GuestState, Address2: this.state.GuestAddress2, ZIP: this.state.GuestZipCode, RegistrantType: this.state.GuestType, RegistrantTypeOther: this.state.GuestTypeOther };
        arrNew.push(newObj);
        this.setState({ Registrants_arr: arrNew });
        this.Clear();
        this.setState({ Registrantmodal: false });
    };
    AdditionalRegistrants.prototype.GridBind = function () {
        var _this = this;
        //
        this.GetArrayObj();
        return this.state.Registrants_arr.map(function (row, index) {
            return React.createElement("div", { style: { display: "flex" } },
                React.createElement("div", { style: { border: "1px solid #ccc", width: "150px" } }, row.Fname),
                React.createElement("div", { style: { border: "1px solid #ccc", width: "150px" } }, row.Lname),
                React.createElement("div", { style: { border: "1px solid #ccc", width: "150px" } },
                    React.createElement("a", { style: { color: "#007bff", cursor: "pointer", margin: "0px 10px" }, onClick: function () { return _this.FillForm(index); }, title: 'Update Guest' }, " Edit"),
                    " ",
                    React.createElement("a", { style: { color: "#007bff", cursor: "pointer", margin: "0px 10px" }, onClick: function () { _this.Delete(index); }, title: 'Delete Guest' }, "Remove")));
        });
    };
    AdditionalRegistrants.prototype.GetArrayObj = function () {
        var objFinal = '';
        var arr = __spreadArray([], this.state.Registrants_arr);
        //Prepare the string as (Fname,Lname,Email,Address1,Address2,City,State,Zip,RegistrantType,RegistrantTypeOther|Fname,Lname,Email,Address1,Address2,City,State,Zip,RegistrantType,RegistrantTypeOther)
        for (var i = 0; i < arr.length; i++) {
            objFinal += (arr[i].Fname + ',' + arr[i].Lname + ',' + arr[i].Email + ',' + arr[i].Address1 + ',' + arr[i].Address2 + ',' + arr[i].City + ',' + arr[i].State + ',' + arr[i].ZIP + ',' + arr[i].RegistrantType + ',' + arr[i].RegistrantTypeOther + '|');
        }
        this.props.onSelectGuests(objFinal);
    };
    AdditionalRegistrants.prototype.FillForm = function (index) {
        if (index < 0)
            return;
        //var tdGuestType = document.getElementById('tdGuestType');
        this.setState({ GuestRowIndex: index });
        var arr = __spreadArray([], this.state.Registrants_arr);
        var obj = arr[index];
        this.setState({ GuestFName: obj.Fname });
        this.setState({ GuestLName: obj.Lname });
        this.setState({ GuestEmail: obj.Email });
        this.setState({ GuestAddress1: obj.Address1 });
        this.setState({ GuestCity: obj.City });
        this.setState({ GuestZipCode: obj.ZIP });
        this.setState({ GuestAddress2: obj.Address2 });
        this.setState({ GuestState: obj.State });
        this.setState({ GuestType: obj.RegistrantType });
        this.setState({ GuestTypeOther: obj.RegistrantTypeOther });
        if (obj.RegistrantType == "Other") {
            this.setState(function () { return ({ tdGuestOther: { display: 'block' } }); });
        }
        else {
            this.setState(function () { return ({ tdGuestOther: { display: 'none' } }); });
        }
        this.setState(function () { return ({ AddTitle: { display: 'none' } }); });
        this.setState(function () { return ({ UpdateTitle: { display: 'flex' } }); });
        this.setState(function () { return ({ divCheckbox: { display: 'none' } }); });
        this.setState({ Registrantmodal: true });
    };
    AdditionalRegistrants.prototype.Edit = function () {
        var arrNew = __spreadArray([], this.state.Registrants_arr);
        var index = parseInt(this.state.GuestRowIndex, 10);
        if (index < 0)
            return;
        //Get current row obj from index
        var obj = arrNew[index];
        obj.Fname = this.state.GuestFName;
        obj.Lname = this.state.GuestLName;
        obj.Email = this.state.GuestEmail;
        obj.Address1 = this.state.GuestAddress1;
        obj.Address2 = this.state.GuestAddress2;
        obj.City = this.state.GuestCity;
        obj.State = this.state.GuestState;
        obj.ZIP = this.state.GuestZipCode;
        obj.RegistrantType = this.state.GuestType;
        obj.RegistrantTypeOther = this.state.GuestTypeOther;
        this.setState({ Registrants_arr: arrNew });
        this.setState({ Registrantmodal: false });
        this.Clear();
    };
    AdditionalRegistrants.prototype.Delete = function (index) {
        this.setState({ GuestRowIndex: index });
        this.setState({ DeleteModal: true });
    };
    AdditionalRegistrants.prototype.DeleteGuest = function () {
        var arrNew = __spreadArray([], this.state.Registrants_arr);
        var index = parseInt(this.state.GuestRowIndex, 10);
        if (index > -1) {
            arrNew.splice(index, 1);
        }
        this.setState({ Registrants_arr: arrNew });
        this.setState({ DeleteModal: false });
    };
    AdditionalRegistrants.prototype.validate = function () {
        var fname = this.state.GuestFName;
        var lname = this.state.GuestLName;
        var email = this.state.GuestEmail;
        var address1 = this.state.GuestAddress1;
        var city = this.state.GuestCity;
        var state = this.state.GuestState;
        var ZIP = this.state.GuestZipCode;
        var registrantType = this.state.GuestType;
        var registrantTypeOther = this.state.GuestTypeOther;
        if (lname === '' || fname === '' || city === '' || address1 === '' || state === '' || ZIP === '' || registrantType === '' || registrantType == 'Other' && registrantTypeOther == '') {
            this.setState({ lblResult: "Please enter all the required fields." });
            return false;
        }
        if (email !== '' && !this.validateEmail(email)) {
            this.setState({ lblResult: email + " is not valid email. Please enter valid email." });
            return false;
        }
        if (!this.validateZIP(ZIP)) {
            this.setState({ lblResult: ZIP + " is not valid ZIP Code. Please enter Only 5 digit." });
            return false;
        }
        return true;
    };
    AdditionalRegistrants.prototype.validateEmail = function (email) {
        var re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(email);
    };
    AdditionalRegistrants.prototype.validateZIP = function (ZIP) {
        var re = /^((\d{5}(-|\s)\d{0,4})|(\d{5}))$/;
        return re.test(ZIP);
    };
    AdditionalRegistrants.prototype.handleGuestTypeOther = function (e) {
        var txtGuestTypeOther = document.getElementById('txtGuestTypeOther');
        this.setState({ GuestType: e.target.value });
        if (e.target.value == 'Other') {
            this.setState(function () { return ({ tdGuestOther: { display: 'block' } }); });
            if (txtGuestTypeOther != null)
                txtGuestTypeOther.setAttribute("required", "");
        }
        else {
            this.setState(function () { return ({ tdGuestOther: { display: 'none' } }); });
            if (txtGuestTypeOther != null)
                txtGuestTypeOther.removeAttribute("required");
        }
    };
    AdditionalRegistrants.prototype.render = function () {
        var _this = this;
        return (React.createElement(React.Fragment, null,
            React.createElement("div", null,
                React.createElement("span", { style: { fontSize: "12px", color: "#666666" } },
                    "Attending Guests",
                    React.createElement("sup", null, "\u2020"),
                    ":"),
                React.createElement(reactstrap_1.Button, { onClick: this.ShowRegistrantModal, className: "btn-primary" }, "Add Guest"),
                React.createElement(reactstrap_1.Modal, { isOpen: this.state.Registrantmodal, toggle: this.toggle },
                    React.createElement(reactstrap_1.ModalHeader, { style: this.state.AddTitle, id: "AddTitle", toggle: this.CloseRegistrantModal }, "Add Attending Guest Information"),
                    React.createElement(reactstrap_1.ModalHeader, { style: this.state.UpdateTitle, id: "EditTitle", toggle: this.CloseRegistrantModal }, "Update Attending Guest Information"),
                    React.createElement("form", { onSubmit: this.handleSubmit },
                        React.createElement(reactstrap_1.ModalBody, null,
                            React.createElement("div", { className: "row" },
                                React.createElement("div", { className: "regColumn" },
                                    React.createElement("span", { style: { color: "Red" } }, "*"),
                                    React.createElement("span", { style: { fontSize: "12px", color: "#666666" } }, "First Name:"),
                                    React.createElement("input", { type: "text", className: "fieldcontrolguest", value: this.state.GuestFName, onChange: function (e) { _this.setState({ GuestFName: e.target.value }); }, name: "firstname", "aria-label": "firstname", required: true })),
                                React.createElement("div", { className: "regColumn" },
                                    React.createElement("span", { style: { color: "Red" } }, "*"),
                                    React.createElement("span", { style: { fontSize: "12px", color: "#666666" } }, "Last Name:"),
                                    React.createElement("input", { value: this.state.GuestLName, className: "fieldcontrolguest", type: "text", onChange: function (e) { _this.setState({ GuestLName: e.target.value }); }, name: "lastname", "aria-label": "lastname", required: true })),
                                React.createElement("div", { className: "regColumn" },
                                    React.createElement("span", { style: { fontSize: "12px", color: "#666666" } }, "Email:"),
                                    React.createElement("input", { value: this.state.GuestEmail, className: "fieldcontrolguest", type: "text", onChange: function (e) { _this.setState({ GuestEmail: e.target.value }); }, name: "email", "aria-label": "email", pattern: "[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,}$" }))),
                            React.createElement("div", { style: this.state.divCheckbox, className: "row" },
                                React.createElement("div", { className: "regColumn" },
                                    React.createElement("input", { type: "checkbox", id: "cbsameaddress", name: "cbsameaddress", "aria-label": "usesameaddress", onChange: function (e) { return _this.handleSameAddress(e); } }),
                                    React.createElement("label", { className: "labelcheckboxes" }, "Use Same Address"))),
                            React.createElement("div", { className: "row" },
                                React.createElement("div", { className: "regColumn" },
                                    React.createElement("span", { style: { color: "Red" } }, "*"),
                                    React.createElement("span", { style: { fontSize: "12px", color: "#666666" } }, "Address1:"),
                                    React.createElement("input", { value: this.state.GuestAddress1, className: "fieldcontrolguest", type: "text", onChange: function (e) { _this.setState({ GuestAddress1: e.target.value }); }, name: "address1", "aria-label": "address1", required: true })),
                                React.createElement("div", { className: "regColumn" },
                                    React.createElement("span", { style: { fontSize: "12px", color: "#666666" } }, "Address2:"),
                                    React.createElement("input", { value: this.state.GuestAddress2, className: "fieldcontrolguest", type: "text", onChange: function (e) { _this.setState({ GuestAddress2: e.target.value }); }, name: "address2", "aria-label": "address2" })),
                                React.createElement("div", { className: "regColumn" },
                                    React.createElement("span", { style: { color: "Red" } }, "*"),
                                    React.createElement("span", { style: { fontSize: "12px", color: "#666666" } }, "City:"),
                                    React.createElement("input", { value: this.state.GuestCity, className: "fieldcontrolguest", type: "text", onChange: function (e) { _this.setState({ GuestCity: e.target.value }); }, name: "city", "aria-label": "city", required: true }))),
                            React.createElement("div", { className: "row" },
                                React.createElement("div", { className: "regColumn" },
                                    React.createElement("span", { style: { color: "Red" } }, "*"),
                                    React.createElement("span", { style: { fontSize: "12px", color: "#666666" } }, "State:"),
                                    React.createElement("select", { "data-val": "true", value: this.state.GuestState, className: "fieldcontrolguest", "aria-label": "state", onChange: function (e) { _this.setState({ GuestState: e.target.value }); }, required: true }, this.state.ddlState.map(function (state) {
                                        return React.createElement("option", { key: state.itemValue, value: state.itemValue }, state.itemText);
                                    }))),
                                React.createElement("div", { className: "regColumn" },
                                    React.createElement("span", { style: { color: "Red" } }, "*"),
                                    React.createElement("span", { style: { fontSize: "12px", color: "#666666" } }, "Zip Code:"),
                                    React.createElement("div", null,
                                        React.createElement(kendo_react_inputs_1.MaskedTextBox, { mask: "#####", name: "zipcode", "aria-labelledby": "zipcode", className: "fieldcontrolguest", key: "number", id: "mtZipcode", value: this.state.GuestZipCode, onChange: function (e) { {
                                                _this.setState({ GuestZipCode: e.target.value });
                                            } }, required: true }))),
                                React.createElement("div", { className: "regColumn" },
                                    React.createElement("span", { style: { color: "Red" } }, "*"),
                                    React.createElement("span", { style: { fontSize: "12px", color: "#666666" } }, "Guest is:"),
                                    React.createElement("div", null,
                                        React.createElement("select", { "data-val": "true", value: this.state.GuestType, className: "fieldcontrolguest", "aria-label": "guesttype", onChange: function (e) { _this.handleGuestTypeOther(e); }, required: true }, this.state.ddlGuestType.map(function (guest) {
                                            return React.createElement("option", { key: guest.itemValue, value: guest.itemValue }, guest.itemText);
                                        })),
                                        React.createElement("div", { className: "textboxGuestTypeOther" },
                                            React.createElement("div", { id: "tdGuestType", style: this.state.tdGuestOther },
                                                React.createElement("input", { id: "txtGuestTypeOther", type: "text", value: this.state.GuestTypeOther, name: "guesttypeother", "aria-label": "guesttypeother", className: "fieldcontrolguest", onChange: function (e) { _this.setState({ GuestTypeOther: e.target.value }); } })))))),
                            React.createElement("div", { className: "row", style: { paddingTop: "8px" } },
                                React.createElement("div", { className: "popUpDivBorderPadding" },
                                    React.createElement("div", { className: "borderText" },
                                        React.createElement("p", { className: "pBottom" },
                                            React.createElement("b", null,
                                                "Please note that all attendees must be 12 years of age or older,",
                                                React.createElement("br", null),
                                                " as well as an HAE patient or caregiver, to attend this program.")))))),
                        React.createElement(reactstrap_1.ModalFooter, { style: { margin: "0px" } },
                            React.createElement("span", { style: { color: "Red" } }, this.state.lblResult),
                            React.createElement(reactstrap_1.Button, { type: "submit", color: 'primary', style: this.state.AddTitle, onClick: function () { return (_this.state.button = 'add'); } }, "Add"),
                            "\u00A0\u00A0",
                            React.createElement(reactstrap_1.Button, { type: "submit", color: 'primary', style: this.state.UpdateTitle, onClick: function () { return (_this.state.button = 'update'); } }, "Update"),
                            "\u00A0\u00A0",
                            React.createElement(reactstrap_1.Button, { style: { backgroundColor: '#8A8A8A', borderColor: '#8A8A8A', color: '#fff' }, onClick: this.CloseRegistrantModal }, "Close"))))),
            React.createElement(reactstrap_1.Modal, { isOpen: this.state.DeleteModal },
                React.createElement(reactstrap_1.ModalHeader, { id: "AddTitle", toggle: this.CloseDeleteModal }, "Delete Attending Guest"),
                React.createElement(reactstrap_1.ModalBody, null,
                    React.createElement("span", null, "Are you sure you want to delete this guest?")),
                React.createElement(reactstrap_1.ModalFooter, null,
                    React.createElement(reactstrap_1.Button, { color: 'primary', style: { padding: '3px 15px 3px 15px' }, onClick: this.DeleteGuest }, "Ok"),
                    "\u00A0\u00A0",
                    React.createElement(reactstrap_1.Button, { style: { backgroundColor: '#8A8A8A', borderColor: '#8A8A8A', color: '#fff' }, onClick: this.CloseDeleteModal }, "Close"))),
            React.createElement("div", { style: { padding: "10px 0px" } },
                React.createElement("div", { className: "tblguest divtblguest" },
                    React.createElement("div", { id: "tblRegistrant", className: "Registrants_Tbl" },
                        React.createElement("div", { className: "addGuestGridHeader" },
                            React.createElement("div", { style: { width: "150px", backgroundColor: "#e2e2e2", color: "#000", fontWeight: "normal", fontSize: "12px", padding: "2px 5px", border: "1px solid #ccc" } }, "First Name"),
                            React.createElement("div", { style: { width: "150px", backgroundColor: "#e2e2e2", color: "#000", fontWeight: "normal", fontSize: "12px", padding: "2px 5px", border: "1px solid #ccc" } }, "Last Name"),
                            React.createElement("div", { style: { width: "150px", backgroundColor: "#e2e2e2", color: "#000", fontWeight: "normal", fontSize: "12px", padding: "2px 5px", border: "1px solid #ccc" } }, "Action")),
                        this.state.Registrants_arr.length === 0 ?
                            (React.createElement("div", { id: "trNoRecords" },
                                React.createElement("div", { style: { textAlign: "left", color: "#000", fontWeight: "normal", fontSize: "12px", padding: "2px 5px", border: "1px solid #ccc" } }, "No Guests have been added"))) :
                            (this.GridBind())),
                    React.createElement("br", null),
                    React.createElement("sup", null, "\u2020"),
                    "To accommodate your guests properly, please provide information here."))));
    };
    return AdditionalRegistrants;
}(React.PureComponent));
exports.default = AdditionalRegistrants;
//# sourceMappingURL=AdditionalRegistrants.js.map